module.exports = __webpack_public_path__ + "static/media/UserDefault.4289f2ce.svg";